import Parallax from 'parallax-js'


let headerParallax = {
    init() {
        if($('body').hasClass('page-node-type-marque')){
            if(window.screenSize > 755){
                this.anim();
            }
        }
    },
    anim() {
        var scene = document.getElementById('scene');
        var parallaxInstance = new Parallax(scene, {
          relativeInput: true,
          hoverOnly : true
        });
    }
}

export default headerParallax;
